<div class='ot-loading-dots-container'>
  <div id="dot_1" class="ot-loading-dot"></div>
  <div id="dot_2" class="ot-loading-dot"></div>
  <div id="dot_3" class="ot-loading-dot"></div>
</div>